import { valueIsDefined } from "../utils/utils";

// The store product options saved on a part line, one "Option name: value" per line, in the same labeled-row
// style the line lists use for Summary, Equipment, and Technician. Nothing renders for a line without options.
function LineItemStoreOptions(props) {
    const { lineItem } = props
    const platformOptions = valueIsDefined(lineItem.platform_options) ? lineItem.platform_options : []

    if (platformOptions.length === 0) {
        return null
    } else {
        return (
            <div className="line-item-label__row">
                <div className="line-item-label__field">
                    <div className="line-item-label__field-label">Store Options</div>
                    <div className="line-item-label__field-value preserve-whitespace">
                        {platformOptions.map(option => `${option.modifier_name}: ${option.value_label}`).join("\n")}
                    </div>
                </div>
            </div>
        )
    }
}

export default LineItemStoreOptions
